import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  bcpSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './assessment-document.controller';
import directive from './assessment-document.directive';

export default angular.module('app.components.advisory.bcp.assessmentDocument', [
  alerts,
  bcpDataService,
  bcpSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('bcpAssessmentDocument', directive)
  .controller('BCPAssessmentDocumentController', controller)
  .name;

console.log('app.components.advisory.bcp.assessmentDocument created');
